import React from 'react'
import { Grid, Typography, InputLabel } from '@material-ui/core'
import { InputField } from '../../FormFields'

import './CreateGeneralForm.scss'

function CreateGeneralForm(props) {
    return (
        <div className="CreateGeneralForm" data-test-id="usecase-create_general_form">
            <React.Fragment>
                <Typography variant="h6" gutterBottom>
                    General
                </Typography>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={12}>
                        <InputLabel shrink>
                            Use Case Name <span className="RequiredRed">*</span>
                        </InputLabel>
                        <InputField type="text" name={'name'} fullWidth data-test-id="usecase-create_general_form_name" />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <InputLabel shrink>Use Case Duration in seconds (empty value equals infinite)</InputLabel>
                        <InputField name={'max_duration'} label={''} fullWidth data-test-id="usecase-create_general_form_maxduration" />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <InputLabel shrink>Environment Configuration Id</InputLabel>
                        <InputField
                            name={'environment_config_id'}
                            label={''}
                            fullWidth
                            data-test-id="usecase-create_general_form_environment_id"
                        />
                    </Grid>
                </Grid>
            </React.Fragment>
        </div>
    )
}

export default CreateGeneralForm
